import {h, Fragment} from "preact"
import { useFacets, useRangeSlider, useFacet } from "@nosto/preact"
import { facetConfigs } from "../config"

import Checkbox from "./elements/Checkbox"

function MergedFacetWrap({ facet, mergeFacet }) {
    const { toggleProductFilter } = useFacet(facet);

    return (
        <>
            {mergeFacet.newFilters.map(newFilter => {
                const filter = facet.data.find(f => f.value === newFilter.value);
                if(!filter) return null;

                return (
                    <li
                        key={newFilter.id}
                        class="ns-filter"
                        role="menuitem"
                        data-nosto-element="facet-setting"
                    >
                        <Checkbox 
                            valueName={facetConfigs[facet.id]?.nameMap?.[newFilter.value] || newFilter.value}
                            value={newFilter.value}
                            selected={newFilter.selected}
                            id={`ns-${facet.id}-${newFilter.value.toString().toLowerCase().replace(/\s+/g, '-')}`}
                            onChange={e => {
                                e.preventDefault()
                                toggleProductFilter(facet.field, newFilter.value, !filter.selected)
                            }}
                        />
                    </li>
                )
            })}
        </>
    )
}

function MergedRangeWrap({ facet, mergeFacet }) {
    const { min, max, range, updateRange } = useRangeSlider(facet.id);

    return (
        <>
            {mergeFacet.newFilters.map(newFilter => {
                const selected = range[0] === newFilter.min && range[1] === newFilter.max;
                if(min > newFilter.min || max < newFilter.max) return null;

                return (
                    <li
                        key={newFilter.id}
                        class="ns-filter"
                        role="menuitem"
                    >
                        <Checkbox 
                            valueName={facetConfigs[facet.id]?.nameMap?.[newFilter.value] || newFilter.value}
                            value={newFilter.value}
                            selected={selected}
                            id={`ns-${facet.id}-${newFilter.value.toString().toLowerCase().replace(/\s+/g, '-')}`}
                            onChange={e => {
                                e.preventDefault()
                                    updateRange(selected 
                                        ? [min, max] 
                                        : [newFilter.min, newFilter.max]      
                                    )                                
                            }}
                        />
                    </li>
                )
            })}
        </>
    )
}

export default function MergedFacetValues({ mergedFacets }) {
    const { facets } = useFacets();

    return (
        <>
            {mergedFacets.map(mergeFacet => {
                const facet = facets.find(f => f.id === mergeFacet.facetId);
                if(!facet || !mergeFacet.newFilters?.length) return null;

                return (mergeFacet.isRange ? (
                    <MergedRangeWrap
                        key={mergeFacet.facetId}
                        facet={facet}
                        mergeFacet={mergeFacet}
                    />
                ) : (
                    <MergedFacetWrap
                        key={mergeFacet.facetId}
                        facet={facet}
                        mergeFacet={mergeFacet}
                    />
                )) 
            })}
        </>
    )
}
